module.exports = __webpack_public_path__ + "static/media/gallery.eee3d0d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/gallery.svg
// module id = 398
// module chunks = 0